import { magnetWorkSettingsOperations } from "./../../redux/magnetWorkSettings";
import { reverse, sortBy } from "lodash";
import { domainKeys } from "./../../modules/magnetDomains";

export const calculateBestCombinations = (magnetWorkSettings, benchmarks, dispatch) => {
  const state = {};
  const domainPass = (unit, key, benchmarkName) => {
    const magnetWorkSetting = magnetWorkSettings[unit];
    const value = magnetWorkSetting.domains[key][0].data[0].percent;
    const benchmark = benchmarks.data[benchmarkName][key];
    return value > benchmark;
  }
  const distanceFromBenchmark = (unit, key, benchmarkName) => {
    const magnetWorkSetting = magnetWorkSettings[unit];
    const value = magnetWorkSetting.domains[key][0].data[0].percent;
    const benchmark = benchmarks.data[benchmarkName][key];
    if (typeof value === "number") {
      return value - benchmark;
    } else {
      return -100;
    }
  }
  const units = sortBy(Object.keys(magnetWorkSettings));
  const domainCombinations = [];
  const benchmarkCombinations = [];
  const populateBenchmarkCombinations = (units, combination) => {
    if (units.length > 0) {
      const unit = units[0];
      const magnetWorkSetting = magnetWorkSettings[unit];
      magnetWorkSetting.selectedBenchmarks.forEach(benchmark => {
        populateBenchmarkCombinations(units.slice(1), {...combination, [unit]: benchmark});
      });
    } else {
      benchmarkCombinations.push(combination);
    }
  };
  populateBenchmarkCombinations(units, {})
  benchmarkCombinations.forEach(benchmarkCombination => {
    for (let i = 0; i < domainKeys.length - 3; i++) {
      for (let j = i + 1; j < domainKeys.length - 2; j++) {
        for (let k = j + 1; k < domainKeys.length - 1; k++) {
          for (let l = k + 1; l < domainKeys.length; l++) {
            const combination = {
              domainOne: domainKeys[i],
              domainTwo: domainKeys[j],
              domainThree: domainKeys[k],
              domainFour: domainKeys[l],
              benchmarks: benchmarkCombination,
              pass: 0,
              passFour: 0,
              passThree: 0,
              passTwo: 0,
              passOne: 0,
              passZero: 0,
              units: [],
              distance: 0,
              filteredDistance: 0,
            };
            for (let m = 0; m < units.length; m++) {
              const unit = units[m];
              let passCount = 0;
              passCount += domainPass(unit, combination.domainOne, benchmarkCombination[unit]) ? 1 : 0;
              passCount += domainPass(unit, combination.domainTwo, benchmarkCombination[unit]) ? 1 : 0;
              passCount += domainPass(unit, combination.domainThree, benchmarkCombination[unit]) ? 1 : 0;
              passCount += domainPass(unit, combination.domainFour, benchmarkCombination[unit]) ? 1 : 0;
              const distanceOne = distanceFromBenchmark(unit, combination.domainOne, benchmarkCombination[unit]);
              const distanceTwo = distanceFromBenchmark(unit, combination.domainTwo, benchmarkCombination[unit]);
              const distanceThree = distanceFromBenchmark(unit, combination.domainThree, benchmarkCombination[unit]);
              const distanceFour = distanceFromBenchmark(unit, combination.domainFour, benchmarkCombination[unit]);
              const distance = distanceOne + distanceTwo + distanceThree + distanceFour;
              let filteredDistance = 0;
              if (distanceOne < 0) {
                filteredDistance += distanceOne;
              }
              if (distanceTwo < 0) {
                filteredDistance += distanceTwo;
              }
              if (distanceThree < 0) {
                filteredDistance += distanceThree;
              }
              if (distanceFour < 0) {
                filteredDistance += distanceFour;
              }
              let worstDistanceFromBenchmark = distanceOne;
              if (distanceTwo < worstDistanceFromBenchmark) {
                worstDistanceFromBenchmark = distanceTwo;
              }
              if (distanceThree < worstDistanceFromBenchmark) {
                worstDistanceFromBenchmark = distanceThree;
              }
              if (distanceFour < worstDistanceFromBenchmark) {
                worstDistanceFromBenchmark = distanceFour;
              }
              combination.units.push({
                name: unit,
                passCount,
                filteredDistance,
                distance,
                worstDistanceFromBenchmark,
              });
              combination.distance += distance;
              combination.filteredDistance += filteredDistance;
              if (passCount >= 3) {
                combination.pass += 1;
              }
              switch (passCount) {
                case 4:
                  combination.passFour += 1;
                  break;
                case 3:
                  combination.passThree += 1;
                  break;
                case 2:
                  combination.passTwo += 1;
                  break;
                case 1:
                  combination.passOne += 1;
                  break;
                case 0:
                  combination.passZero += 1;
                  break;
                default:
                  break;
              }
            }
            combination.units = reverse(sortBy(combination.units, ["passCount", "filteredDistance", "distance"]));
            domainCombinations.push(combination);
          }
        }
      }
    }
  });
  state.domainCombinations = reverse(
    sortBy(domainCombinations, ["pass", "passFour", "passThree", "passTwo", "passOne", "filteredDistance", "distance"])
  );
  state.domainCombinationSelected = 0;
  state.domainCombinations[0].units.forEach(unit => {
    dispatch(magnetWorkSettingsOperations.applyBenchmark(unit.name, state.domainCombinations[0].benchmarks[unit.name]));
  });
  return state;
}



// WEBPACK FOOTER //
// ./src/lib/magnetAlgorithm/index.js